import React, { useState, memo, useEffect } from "react";
import { Row ,Col,Card,Button} from 'react-bootstrap';
import Sound from 'react-sound';
// import MicRecorder from 'mic-recorder-to-mp3';
import { base, s3base } from "api.js";
import HeadsetCheck from "components/FullTest/ResourceChecking/HeadsetCheck";
import MicrophoneCheck from "components/FullTest/ResourceChecking/MicrophoneCheck";
import KeyboardCheck from "components/FullTest/ResourceChecking/KeyboardCheck";
import TestIntroduction from "components/FullTest/ResourceChecking/TestIntroduction";
import SpeakingInstructions from "components/FullTest/ResourceChecking/SpeakingInstructions";
import FullScreen from "assets/images/FullScreen.png";
import DarkMode from "assets/images/DarkMode.png";
import ExitFullScreen from "assets/images/ExitFullScreen.png";
import LightMode from "assets/images/LightMode.png";
import { toggleFullScreen, toggleTheme, isFullScreen, isDarkMode } from "util/helper";

export default function ResourceCheck(props) {

	const [checkpoint, setCheckPoint] = useState(1);
	const [nextFlag, setNextFlag] = useState(false);
	const [, forceUpdate] = useState();
	console.log(isFullScreen());
	
	useEffect(() => {
		if (checkpoint > 5) {
			props.setStep(prev => (prev + 1));
		}
	}, [checkpoint]);

	const nextButton = (e) => {
		setCheckPoint(prev => (prev + 1));
		setNextFlag(false);
	};
	
	return (
		<div className="content questionsArea deviceTestPage old-design p-0 test_width mock-container" id="test-card">
			<Row>
				<Col xs={12}>
					{/* TestHeader - Same as SectionalTest */}
					<Row className="m-0 test_width">
						<Row
							className="d-flex justify-content-between align-items-center w-100 h-50 mock-header-bg"
							style={{
								// backgroundColor: "#BFBABB",
								height: "40px	!important",
							}}
						>
							<Col
								style={{
									width: "fit-content",
									padding: "0",
								}}
							>
								<Card.Title tag="h4" className="m-0 mx-2">
									Language Academy - Full Mock Test
								</Card.Title>
							</Col>
						</Row>
						<Row
							style={{
								backgroundColor: "#0081A4",
								minHeight: "40px",
							}}
							className="d-flex justify-content-end align-items-center px-4"
						>
							<div className="d-flex justify-content-end gap-3">
								{/* <i className="fa fa-expand text-white" style={{ cursor: "pointer" }}></i>
								<i className="fa fa-moon-o text-white" style={{ cursor: "pointer" }}></i> */}
							<img
							  src={isFullScreen() ? ExitFullScreen : FullScreen}
							  onClick={() => {
								toggleFullScreen();
								setTimeout(() => {
									forceUpdate({});
								}, 100);
							  }}
							  alt={isFullScreen() ? "Exit Full Screen" : "Full Screen"}
							  className="toggle-icons"
							/>
							<img
							  src={isDarkMode() ? LightMode : DarkMode}
							  onClick={() => {
								toggleTheme();
								forceUpdate({});
							  }}
							  alt={isDarkMode() ? "Light Mode" : "Dark Mode"}
							  className="toggle-icons"
							/>							
							</div>
						</Row>
					</Row>

					{/* Content with proper padding */}
					<div style={{ padding: "20px 40px 40px", paddingBottom: "80px" }}>
						{checkpoint === 1 &&
							<HeadsetCheck
								setNextFlag={setNextFlag}
							/>
						}

						{checkpoint === 2 &&
							<MicrophoneCheck
								setNextFlag={setNextFlag}
							/>
						}

						{checkpoint === 3 &&
							<KeyboardCheck
								setNextFlag={setNextFlag}
							/>
						}

						{checkpoint === 4 &&
							<TestIntroduction
								setNextFlag={setNextFlag}
							/>
						}

						{checkpoint === 5 &&
							<SpeakingInstructions
								setNextFlag={setNextFlag}
							/>
						}
					</div>
				</Col>

				{/* BottomBtns - Same as SectionalTest */}
				<Col xs={12}>
					<div className="bottomBtns fixed-bottom-row mock-header-gap">
						<Row className="align-items-center mx-0 gap-1 fixed-bottom-row w-100 mock-header-gap">
							{/* <Col xs="auto" className="d-flex justify-content-center align-items-center py-1 mock-bottom-btn-toggle" style={{ minWidth: "15%",minHeight: "50px" }}></Col> */}
							<Col className="text-center py-2 z-3 mock-bottom-btn-toggle flex-grow-1" style={{ minHeight: "50px" }}></Col>
							<Col xs="auto" className="d-flex justify-content-center align-items-center py-1 mock-bottom-btn-toggle" style={{ minWidth: "20%",minHeight: "50px" }}>
								<Button
									variant="primary"
									disabled={!nextFlag}
									onClick={nextButton}
									size="xs"
									className="mock-btn bottomBtnFont d-flex align-items-center"
								>
									NEXT
								</Button>
							</Col>
						</Row>
					</div>
				</Col>
			</Row>
		</div>
	);
}